import Service from "../../Service";

const resource = "HmnRecruitmentProcess/";

export default {
  save(item, requestID) {
    return Service.post(resource + "save", item, {
      params: { requestID: requestID },
    });
  },
  pagination(parameters, requestID, axiosSource) {
    const config = {
      params: { requestID: requestID },
    };

    if (axiosSource) config.cancelToken = axiosSource.token;

    return Service.post(resource + "paginate", parameters, config);
  },
  byID(RprID, requestID) {
    return Service.post(resource + "byID", null, {
      params: { RprID: RprID, requestID: requestID },
    });
  },
  update(item, requestID) {
    return Service.post(resource + "update", item, {
      params: { requestID: requestID },
    });
  },
  getCandidates(RprID, requestID, CprFile = 0, CprStatus = null) {
    return Service.post(resource + "getCandidates", null, {
      params: { RprID: RprID, CprFile: CprFile, CprStatus: CprStatus, requestID: requestID },
    });
  },
  getInterviewQuestions(RprID,requestID) {
    return Service.post(resource + "getInterviewQuestions", null, {
      params: { RprID: RprID,requestID: requestID },
    });
  },
  ExportInterviewByRequirement(ReqID,CprFile, requestID) {    
    return Service.post(resource + "ExportInterviewByRequirement", null, {
      params: { ReqID: ReqID, CprFile:CprFile , requestID: requestID },
    });
  },
  archive(item, requestID) {
    return Service.post(resource + "archive", item, {
      params: { requestID: requestID },
    });
  },
  reopen(item, requestID) {
    return Service.post(resource + "reopen", item, {
      params: { requestID: requestID },
    });
  },
  history(RprID, requestID) {
    return Service.post(resource + "history", null, {
      params: { RprID: RprID, requestID: requestID },
    });
  },
  archiveEmailRecipients(RprID, requestID) {
    return Service.post(resource + "archiveEmailRecipients", null, {
      params: { RprID: RprID, requestID: requestID },
    });
  },
  traceabilityReport(RprID, requestID) {
    return Service.post(resource + "traceabilityReport", null, {
      params: { RprID: RprID || 0, requestID: requestID },
    });
  },
  massiveByDni(payload, requestID) {
    return Service.post(resource + "massiveByDni", payload, {
      params: { requestID: requestID },
    });
  },
  activeMassiveProcesses(CmpID, requestID, TypeRequirement = null) {
    return Service.post(resource + "activeMassiveProcesses", null, {
      params: { CmpID: CmpID, requestID: requestID, TypeRequirement: TypeRequirement },
    });
  },
  massiveByDniMassive(payload, MrcID, requestID) {
    return Service.post(resource + "massiveByDniMassive", payload, {
      params: { MrcID: MrcID, requestID: requestID },
    });
  },
  diagnoseDnis(payload, requestID) {
    return Service.post(resource + "diagnoseDnis", payload, {
      params: { requestID: requestID },
    });
  },
};
